import React, { useContext,Fragment } from 'react'
import {AppSearchInput} from 'qcc'
import {AppSearchItemProps} from './index'
import './index.less'
import {AppTableSearchContext,AppFilter,SearchEnum} from 'qcc'

export const SearchInput = (props:AppSearchItemProps) => {

	const {onItemChange,onSearch,data} = useContext(AppTableSearchContext);
	const value = props.keyName && data[props.keyName] ? data[props.keyName] : '';

	const handleChange = (text?:string) =>{
        let filter:AppFilter = {
            value:text,
            field:props.field || '',
            keyName:props.keyName,
            opr:props.opr || SearchEnum.opr.Or,
            allowClear:true,
            searchItemType:SearchEnum.itemType.commonSearch
		}
		onItemChange(filter)
    }
	
	const renderLable = () =>{
        if(!props.lable) return <Fragment/>
        return <label className='app-search-common-item-lable'>{props.lable}</label>
    }

	return (<div className='app-search-common-item'>
	{renderLable()}
	<div className='app-search-common-item-content' style={{width:props.itemWidth || 300}}> 
		<AppSearchInput 
			placeholder={props.placeholder} 
			value={value}
			onChange = {handleChange}
			onSearch = {(text:string)=> {onSearch()}}
		/>
	</div>
</div>)
}




// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppSearchInput.tsx